import React, { ReactNode } from 'react';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { Info } from '@drift-labs/icons';
import { cj, cm } from 'src/utils/classNames';
import {
	MARKET_STATS_BAR_CELL_VALUE_CLASSNAME,
	MARKET_STATS_BAR_CELL_VALUE_SKELETON_CLASSNAME,
} from 'src/components/MarketStatsBar/consts';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithChildren, WithClassName {
	leftBorder?: boolean;
	rightBorder?: boolean;
	header: string | ReactNode;
	underline?: boolean;
	headerSize?: 'xs' | 'sm' | 'base' | 'lg';
	headerClassName?: string;
	valueClassName?: string;
	tooltipText?: string;
	onClick?: () => void;
	isLoading?: boolean;
}

const StatDisplay = ({
	className,
	isLoading,
	children,
	leftBorder,
	rightBorder,
	header,
	underline,
	headerClassName,
	valueClassName,
	tooltipText,
	onClick,
}: Props) => {
	const valueContent = (() => {
		if (isLoading) {
			return (
				<SkeletonValuePlaceholder
					className={MARKET_STATS_BAR_CELL_VALUE_SKELETON_CLASSNAME}
					loading
				/>
			);
		}

		return children;
	})();

	return (
		<>
			{leftBorder && <div className="border-r border-stroke-divider" />}

			<div
				className={cm('flex flex-col gap-y-xs', className)}
				role={onClick ? 'button' : undefined}
				onClick={onClick}
			>
				<div
					className={cm(
						'overflow-hidden typo-b4 text-text-secondary select-none',
						underline && 'underline',
						headerClassName
					)}
				>
					{tooltipText ? (
						<Tooltip className="inline-flex items-center" content={tooltipText}>
							{header} <Info size={12} className="ml-xs inline-flex" />
						</Tooltip>
					) : (
						header
					)}
				</div>

				<div
					className={cj(
						'flex grow items-center',
						MARKET_STATS_BAR_CELL_VALUE_CLASSNAME,
						valueClassName
					)}
				>
					{valueContent}
				</div>
			</div>

			{rightBorder && <div className="h-2/3 border-r border-stroke-divider" />}
		</>
	);
};

export default StatDisplay;
